import React, {useEffect, useMemo, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {createStyles, Theme as AugmentedTheme, Grid} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';
import OneLineField from './Inputypes/Oneline';
import NumberField from './Inputypes/Number';
import Select from './Inputypes/Select';
import MultiSelect from './Inputypes/MultiSelect';
import EmailField from './Inputypes/Email';
import PhoneField from './Inputypes/Phone';
import Title from './Inputypes/Title';
import SignatureField from './Inputypes/Signature/Signature';
import ArticleField from './Inputypes/Article/ArticleField';
import CalculationField from './Inputypes/Calculation/CalculationView';
import RadioSelect from './Inputypes/RadioSelect';
import FileField, { FileFieldActions } from './Inputypes/File';

interface IProps {
    fileFieldActions: FileFieldActions
    policy?: string,
    vals: any
    signature?: string,
    fieldChanged: (value: string | string[], sourceField: string, isBusinessId: boolean, fieldType?: string) => void,
    field: CustomInputMappingField
    isRtl: boolean
    setCondition: (val:string) => void,
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    field: {
        width: '100%',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '.2px',
        lineHeight: '20px',
        color: '#202124',

        "&::placeholder": {
            fontSize: '14px',
        },
    },
    inputHolder: {
    },
    descriptionField: {
        paddingTop: 10,
        fontSize: 14
    },
     //@ts-ignore
    inputLabel: theme.inputLabel
}))

const renderInput = (
    fileFieldActions: FileFieldActions,
    field: CustomInputMappingField, 
    valueField: string, 
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
    multipleValues: [],
    selectChangeHandler: (val:string) => void,
    multipleSelectChangeHandler: (val: any[]) => void,
    setCondition:(val:string) => void,
    isRtl: boolean,
    policy?: string,
    signature?: string,
    ) => {

    switch (field.type) {
        case 'text':
        case 'barcode':
        case 'date':
        case 'dateTime':
        case 'paragraph':
        case 'location':
        case 'datatype':
             return <OneLineField isRtl={isRtl} field={field} value={valueField} onChangeHandler={onChangeHandler} />
        case 'signature':
             return <SignatureField policy={policy} signature={signature} isRtl={isRtl} field={field} value={valueField} onChangeHandler={onChangeHandler} />
        case 'article':
             return <ArticleField isRtl={isRtl} field={field} value={valueField} onChangeHandler={onChangeHandler} />
        case 'number':
             return <NumberField isRtl={isRtl}  field={field} value={valueField} onChangeHandler={onChangeHandler}/>
        case 'calculation':
             return <CalculationField isRtl={isRtl}  field={field} value={valueField}/>
        case 'email':
            return <EmailField isRtl={isRtl}  field={field} value={valueField} onChangeHandler={onChangeHandler} sourceField={field.sourceField}/>
        case 'phone':
            return <PhoneField isRtl={isRtl} field={field} value={valueField} onChangeHandler={onChangeHandler} sourceField={field.sourceField}/>
        case 'select': {
            const opts = (field?.options || '').split(";")
            if(opts.length > 0 && opts.length < 3) return <RadioSelect isRtl={isRtl}  field={field} value={valueField} selectChangeHandler={selectChangeHandler} setCondition={setCondition}  />

            return <Select isRtl={isRtl}  field={field} value={valueField} selectChangeHandler={selectChangeHandler} setCondition={setCondition} />
        }
        //@ts-ignore
        case 'file': {
            return <FileField required={!!field?.required} fieldName={field.fieldName} isRtl={isRtl} policy={policy ?? ''} signature={signature ?? ''} sourceField={field.sourceField} fileFieldActions={fileFieldActions} />
        }
        case 'multiSelect':
            return <MultiSelect
                    isRtl={isRtl} 
                    field={field} 
                    multipleValues={multipleValues} 
                    multipleSelectChangeHandler={multipleSelectChangeHandler}
                    />
        case 'title':
            return <Title isRtl={isRtl} field={field}/>
        default:
            return <OneLineField isRtl={isRtl} field={field} value={valueField} onChangeHandler={onChangeHandler} />;
    }
}

export default function CustomInput({ fileFieldActions, field,  fieldChanged ,isRtl,setCondition, policy, signature, vals}: IProps) {
    const classes = useStyles()
    const [valueField, setValueField] = useState<string>('');
    const [multipleValues, setMultipleValues] = useState<any>([]);

    const newV = useMemo(() => {
        if(field.type !== 'calculation') return 'deny'
        return vals[field.sourceField] || ''
    }, [field.sourceField, vals, field.type])

    useEffect(() => {
        if(newV === 'deny') return
        setValueField(newV)
    }, [newV])

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        fieldChanged(e.currentTarget.value, field.sourceField, field.type === 'businessId', field.type );
        setValueField(e.currentTarget.value)
    }

    const selectChangeHandler = (val: string) => {
        fieldChanged(val, field.sourceField, field.type === 'businessId' )
        setValueField(val);
    }

    const multipleSelectChangeHandler = (val: string[]) => {
        fieldChanged(val, field.sourceField, field.type === 'businessId' )
        setMultipleValues([...val]);
    }

    return (
        <Grid container direction="column" style={{  marginRight: isRtl ? '5%' : 0,  paddingLeft: isRtl ? 0 :  '5%',}} className={classes.inputHolder}   >
         {renderInput(fileFieldActions, field, valueField, onChangeHandler, multipleValues, selectChangeHandler, multipleSelectChangeHandler,setCondition, isRtl, policy, signature)}
            <span
             style={{ 
                direction: isRtl ? 'rtl' : 'ltr',
                textAlign: isRtl ? 'right' : 'left' 
            }} 
             className={classes.descriptionField}>
                 {field.fieldDescription && field.fieldDescription}
             </span>   
        </Grid>
  );
}